import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

interface ProvisionChannelsPayload {
    absentChannelName: string;
    celebrationChannelName: string;
}

const useProvisionTeamsIntegrationChannels = () => {
    const userApi = useContainer(UserApi);

    const provisionChannels = (body: ProvisionChannelsPayload): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.provisionTeamsIntegrationChannels({
                body,
                onSuccess: () => resolve(),
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { provisionChannels };
};

export default useProvisionTeamsIntegrationChannels;
